import { UPDATE_INFORMATION_VISIBILITY } from 'redux/actions/informationAction';

const initialState = { visible: true };

export type InformationState = typeof initialState;

export type InformationAction = { type: typeof UPDATE_INFORMATION_VISIBILITY; payload: InformationState }

export const informationRecucer = (
  state: InformationState = initialState, 
  action: InformationAction
): InformationState => {
  switch (action.type) {
    case UPDATE_INFORMATION_VISIBILITY:
      return { 
        ...state,
        ...action.payload 
      };
    default:
      return state;
  }
};
